import { create } from 'zustand';

interface SelectClubMemberFilterStore {
	search: string;
	updateSelectClubMemberSearch: (search: string) => void;
	resetSelectClubMemberFilterStore: () => void;
}

export const useSelectClubMemberFilterStore = create<SelectClubMemberFilterStore>((set) => ({
	search: '',
	updateSelectClubMemberSearch: (search): void => set(() => ({ search })),
	resetSelectClubMemberFilterStore: (): void => set(() => ({ search: '' })),
}));
